import React from "react";
import ReactDOM from "react-dom/client";
import "./ad_remote_client.css";
import App from "./app";
import "./style/global.css";
import "./utils/global_error_handlers";
import { registerServiceWorker } from "./utils/register_sw";

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<App baseUrl={import.meta.env.BASE_URL} />);
}

// PWA(차량 UI 태블릿 설치)용 서비스워커 등록 — 프로덕션에서만 동작.
registerServiceWorker();
